var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"sidebar-menu",attrs:{"default-active":_vm.$route.path,"active-text-color":"#409EFF","collapse":false,"router":""}},_vm._l((_vm.menuList),function(item){return _c('sidebar-item',{key:item.path,attrs:{"item":item,"base-path":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }